<template>
  <div :class="$style.tgStore">
    <h1>
      <!-- <img :src="`${$cdnUrl}/tgStore/xiangzuo.png`" alt=""> -->
      <span>{{ title }}——道具商城</span>
    </h1>
    <img :src="back" alt="" :class="$style.banner" />
    <div :class="$style.game">
      <div :class="$style.gameInfo">
        <img :src="logo" alt="" />
        <div>
          <p :class="$style.title">{{ title }}</p>
          <p v-if="userInfo.account">账号：{{ userInfo.account }}</p>
          <p v-if="userInfo.mobile">手机号：{{ userInfo.mobile }}</p>
          <p v-if="userInfo.role">
            区服：{{ userInfo.server }}&nbsp;&nbsp;&nbsp;&nbsp; 角色：{{ userInfo.role }}
          </p>
        </div>
      </div>
      <ul :class="$style.operate">
        <li @click="showBind">
          <img :src="`${$cdnUrl}/tgStore/switch.png`" alt="" />
          <span>{{ userInfo.role ? '切换角色' : '绑定角色' }}</span>
        </li>
        <li @click="showRecord">
          <img :src="`${$cdnUrl}/tgStore/record.png`" alt="" />
          <span>购买记录</span>
        </li>
        <li @click="contactKf">
          <img :src="`${$cdnUrl}/tgStore/contact.png`" alt="" />
          <span>联系客服</span>
        </li>
      </ul>
    </div>
    <div :class="$style.product">
      <div :class="$style.tabs">
        <div :class="$style.tabsItem">
          <div
            v-for="st in subShopList"
            :key="st.id"
            :class="[activeTab === st.id ? $style.active : '']"
            @click="changeTab(st.id)"
          >
            <span>{{ st.name }}</span>
          </div>
        </div>
      </div>
      <!-- type 为 1 则是周商城 -->
      <!-- v-if="currentSubStoreInfo.type === 1" -->
      <span
        :class="[$style.hint, $style.white_space_pre]"
      >{{ currentSubStoreInfo.rules || '' }}</span>
       <!-- 【消费可激活游戏内首充/累充活动,助您游玩仙界畅通无阻】 -->
      <div
        :class="[$style.hint_2, $style.white_space_pre]"
      >{{ currentSubStoreInfo.introduce || '' }}</div>
      <ul :class="$style.productList">
        <li v-for="(item, index) in currentSubStoreGoods" :key="index" @click="showGoodsDetail(item)">
          <img :src="item.icon" alt="" />
          <div :class="$style.detail">
            <p :class="$style.name">{{ item.name }}</p>
            <p :class="$style.price">
              <span :class="$style.discount" v-if="item.discount">{{ item.discount }}</span>
              <span :class="$style.price">￥{{ item.price }}</span>
              <span :class="$style.original" v-if="item.original_price"
                >原价￥{{ item.original_price }}</span
              >
            </p>
            <p :class="$style.purchase">
              <span v-if="activeTab === 1 && item.quota > 0">每周</span
              ><span v-if="item.quota > 0">限购{{ item.quota }}份</span>
              <span v-if="item.quota == 0" :class="$style.bl">不限购</span>
              <span :class="$style.bl" v-if="item.quota > 0"
                >（{{ item.buy }}/{{ item.quota }}）</span
              >
            </p>
            <p :class="$style.endTime" v-if="item.show_state != 2">
              下架时间：<span>{{ item.end_time }}</span>
            </p>
            <p :class="$style.endTime" v-if="item.show_state == 2">
              上架时间：<span>{{ item.start_time }}</span>
            </p>
          </div>
          <div :class="$style.storeOperate">
            <button v-if="item.show_state == 1" @click.stop="buyGoods(item)">购买</button>
            <button v-if="item.show_state == 2" :class="$style.pre" @click.stop>即将上架</button>
            <button v-if="item.show_state == 3" :class="$style.run" @click.stop>已售罄</button>
            <p>剩余{{ item.surplus }}</p>
          </div>
        </li>
      </ul>
    </div>
    <div :class="$style.bindMask" v-if="bindShow">
      <div :class="$style.bind">
        <h1>
          <span>绑定角色</span>
          <img :src="`${$cdnUrl}/tgStore/close.png`" alt="" @click="closeBind" />
        </h1>

        <div :class="$style.content">
          <p
            style="font-size: 10px; text-align: center; color: #bebebe; margin-bottom: 15px"
            v-if="bind_type == 2 && serverList.length == 0"
          >
            可通过当前游戏账号绑定的手机号+短信进行账号验证
          </p>
          <!-- 绑定账号 -->
          <p v-if="userInfo.account && !updateBindFlag && userInfo.bind_type == 1">
            当前绑定账号：
          </p>
          <p
            :class="$style.accountView"
            v-if="userInfo.account && !updateBindFlag && userInfo.bind_type == 1"
          >
            <span :class="$style.account">{{ userInfo.account }}</span>
            <span :class="$style.btn" @click="changeAccount">更换账号</span>
          </p>
          <!-- 绑定手机号 -->
          <p v-if="userInfo.mobile && !updateBindFlag && userInfo.bind_type == 2">
            当前绑定手机号：
          </p>
          <p
            :class="$style.accountView"
            v-if="userInfo.mobile && !updateBindFlag && userInfo.bind_type == 2"
          >
            <span :class="$style.account">{{ userInfo.mobile }}</span>
            <span :class="$style.btn" @click="changeAccount">更换手机号</span>
          </p>
          <!-- 手机登录 -->
          <div v-if="bind_type == 2 && serverList.length == 0">
            <p v-if="!userInfo.account || updateBindFlag">绑定手机号：</p>
            <Field
              v-model.trim="phoneNumber"
              :class="$style.field"
              type="tel"
              clearable
              error-message-align="right"
            ></Field>
            <p v-if="!userInfo.account || updateBindFlag">验证码：</p>
            <Field
              v-model.trim="phoneCode"
              :class="$style.field"
              type="tel"
              clearable
              error-message-align="right"
            ></Field>

            <Button
              :class="$style['get-code-btn']"
              size="mini"
              type="info"
              plain
              round
              @click="getVerifyCode"
              v-if="!hasVerifyCode"
            >
              获取
            </Button>
            <CountDown
              ref="countDown"
              seconds
              :time="60000"
              format="ss 秒后重发"
              :auto-start="true"
              :style="{ color: '#ccc', fontSize: '12px' }"
              v-if="hasVerifyCode"
              @finish="hasVerifyCode = fasle"
            >
            </CountDown>
            <div style="text-align: center; color: #6b99e6; margin-top: 10px" @click="changeType">
              切换至账号密码验证
            </div>
          </div>
          <!-- 账号密码 -->
          <div v-if="bind_type == 1 && serverList.length == 0">
            <p v-if="!userInfo.account || updateBindFlag">游戏账号：</p>
            <Field
              v-if="!userInfo.account || updateBindFlag"
              v-model.trim="account"
              :class="$style.field"
            ></Field>
            <p v-if="!userInfo.account || updateBindFlag">密码：</p>
            <Field
              v-model.trim="password"
              :class="$style.field"
              type="password"
              v-if="!userInfo.account || updateBindFlag"
            ></Field>
            <div style="text-align: center; color: #6b99e6; margin-top: 25px" @click="changeType">
              切换至手机验证码验证
            </div>
          </div>

          <div v-if="serverList.length != 0">
            <p>选择区服：</p>
            <CSelect
              placeholder="请选择区服"
              :options="serverList"
              :value="server"
              @change="selectServer"
              ref="selectServer"
              @select="$refs.selectRole.active = false"
            ></CSelect>
            <p>选择角色：</p>
            <CSelect
              ref="selectRole"
              placeholder="请选择角色"
              :options="roleList"
              :value="role"
              @change="selectRole"
              @select="$refs.selectServer.active = false"
            ></CSelect>
          </div>
        </div>
        <div :class="$style.btnGroup">
          <!-- <Button :class="$style.nextStep" @click="handleInputBlur" v-if="updateBindFlag||isSelectServer">选择区服</Button> -->
          <Button
            :class="$style.nextStep"
            @click="handleInputBlur"
            v-if="serverList.length == 0"
            style="margin-top: 20px"
            >选择区服</Button
          >
          <Button :class="$style.nextStep" @click="bindRole" v-else>确认绑定</Button>
        </div>
      </div>
    </div>
    <div :class="$style.bindMask" v-if="goodsDetailShow">
      <div :class="$style.intro">
        <h1>
          <span>道具简介</span>
          <img :src="`${$cdnUrl}/tgStore/close.png`" alt="" @click="goodsDetailShow = false" />
        </h1>
        <p>{{ introduce }}</p>
      </div>
    </div>
    <!-- 选择账号弹窗 -->
    <AccountSelectDialog
      ref="accountSelectDialog"
      dialogType="2"
      @select="handleAccountSelect"
    />
  </div>
</template>

<script>
import CSelect from '@/components/Select';
import { Field, Button, CountDown } from 'vant';
import {
  accountCheck,
  serverRoleOption,
  bindRole as bindRoleApi,
  bindUserInfo,
  goodConfig,
  goodsList,
  purchase as purchaseApi,
  shopData,
  send_msg,
  check_code,
  check_code_list,
} from '@/api/tgStore';
import { Toast } from 'vant';
import { mapState } from 'vuex';
import AccountSelectDialog from '@/components/CustomDialogs/AccountSelectDialog.vue';

// 重要：切用户的商城链接继承的这个页面，后续这个页面有调整内容的时候注意一下 cutUSerStore 的影响

export default {
  name: '',
  data() {
    return {
      bind_type: 2, // 1账号/2手机
      phoneCode: '',
      phoneNumber: '',
      back: '',
      logo: '',
      title: '',
      account: '',
      server: '',
      role: '',
      activeTab: 1,
      serverList: [],
      roleList: [],
      password: '',
      bindShow: false,
      configId: '',
      appkey: '',
      introduce: '',
      goodsDetailShow: false,
      updateBindFlag: false,
      lastUserName: '',
      isAccount: false, // 账号手机号切换
      hasVerifyCode: false, // 是否展示验证码倒计时
      isSelectServer: true, //是否展示选择区服
      subShopList: [], // 子商城列表
      subShopGoodsMap: {}, // 商城对应商品的 map
      highlightGoodId: null, // 需要高亮的商品ID
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.tgStore.userInfo,
    }),
    currentSubStoreInfo () {
      if (!Array.isArray(this.subShopList) || !this.subShopList.length) return {}
      const it = this.subShopList.find(i => i.id === this.activeTab)
      return it || {}
    },
    // 当前所选的
    currentSubStoreGoods () {
      return this.subShopGoodsMap[this.activeTab] || []
    }
  },
  mounted() {
    this.initStore();
  },
  components: {
    Field,
    Button,
    CSelect,
    CountDown,
    AccountSelectDialog,
  },
  methods: {
    initStore () {
      const { config_id, tab_id, good_id } = this.$route.query;
      this.configId = config_id;
      
      // 如果URL中有tab_id参数，记录以便稍后设置激活标签
      if (tab_id) {
        this.activeTab = Number(tab_id);
      }
      
      // 如果URL中有good_id参数，记录以便稍后高亮显示
      if (good_id) {
        this.highlightGoodId = good_id;
      }
      
      this.getUserInfo();
      this.getConfig().then(res => {
        this.getProductList().then(() => {
          // 在获取商品列表后，进行商品高亮和滚动处理
          this.$nextTick(() => {
            this.scrollToHighlightedGood();
          });
        });
      })
      shopData({ type: 1, config_id: this.configId });
    },
    // 获取验证码
    getVerifyCode() {
      if (!this.phoneNumber) {
        this.$toast('请先输入手机号码');
        return;
      } else {
        // 校验电话号码
        let a = /^1[0-9]{10}$/;
        if (!a.test(this.phoneNumber)) {
          this.$toast('请输入正确的手机号码');
          return;
        } else {
          send_msg({ phone: this.phoneNumber }).then((res) => {
            console.log(res);
            if (res.code == 1) {
              this.hasVerifyCode = true;
              this.$refs.countDown && this.$refs.countDown.start();
              this.$toast('验证码已发送，请注意查收');
            } else {
              this.$toast('验证码发送失败');
            }
          });
        }
      }
    },

    // 切换至账号密码登录
    changeType(e) {
      e.target.innerText == '切换至账号密码验证' ? (this.bind_type = 1) : (this.bind_type = 2);
      console.log(this.bind_type);
      this.isAccount = !this.isAccount;
      this.hasVerifyCode = false;
    },
    changeAccount() {
      this.updateBindFlag = true;
      this.clearRole();
      this.bind_type = 2;
    },
    contactKf() {
      shopData({ type: 7, config_id: this.configId });
      if (!this.userInfo.role) {
        window.location.href = 'https://h5.hzwxbz3.cn/v2/onlineCustomer';
      } else {
        window.location.href = `https://h5.hzwxbz3.cn/v2/h5/manualCustomer?account=${this.userInfo.account}&server=${this.userInfo.server}&role_name=${this.userInfo.role}`;
      }
    },
    closeBind() {
      this.bindShow = false;
      this.updateBindFlag = false;
      this.lastUserName = '';
      this.serverList = [];
    },
    changeTab(activeTab) {
      this.activeTab = activeTab;
    },
    async buyGoods(item) {
      if (!this.userInfo.roleId) {
        this.$toast('请先登录账号');
        this.bindShow = true;
        return;
      }
      shopData({ 
        type: 8, 
        good_id: item.id, 
        config_id: this.configId, 
        second_shop_name: item.second_shop_name,
        good_name: item.name,
        second_shop_id: item.goods_type,
      });
      try {
        await purchaseApi({ good_id: item.id, config_id: this.configId });
        this.$store.commit('tgStore/CHANGE_STATE', {
          goodsInfo: item,
        });
        this.$router.push({ name: 'tgStore.pay', query: { config_id: this.configId } });
      } catch (error) {
        if (error.message) Toast(error.message);
      }
    },
    showGoodsDetail(item) {
      this.goodsDetailShow = true;
      this.introduce = item.intro;
    },
    // 获取商品
    async getProductList() {
      const promises = this.subShopList.map(sub => {
        const { id } = sub
        return goodsList({ config_id: this.configId, shop_second_id: id })
          .then(res => {
            const { data } = res.data
            this.$set(this.subShopGoodsMap, id, data)
          })
      })
      
      return Promise.all(promises);
    },
    // 获取商城配置
    async getConfig() {
      const r = await goodConfig({ config_id: this.configId });
      this.title = r.data.name;
      this.back = r.data.banner;
      this.logo = r.data.icon;
      this.subShopList = r.data.shop_second || []
      if (this.subShopList.length) {
        // 检查URL中的tab_id是否在子商城列表中存在
        const tabExists = this.subShopList.some(shop => shop.id === this.activeTab);
        
        // 如果URL中没有指定tab_id，或者指定的tab_id不存在，则使用第一个作为默认值
        if (!this.$route.query.tab_id || !tabExists) {
          this.activeTab = this.subShopList[0].id
        }
      }
      this.$store.commit('tgStore/CHANGE_STATE', {
        gameInfo: r.data,
      });
    },
    async getUserInfo() {
      const r = await bindUserInfo({ config_id: this.configId });
      console.log('rrrrr', r);
      if (r.data instanceof Array) {
        localStorage.setItem('sToken', '');
        this.$store.commit('tgStore/CHANGE_STATE', {
          userInfo: {},
        });
        return;
      }
      this.$store.commit('tgStore/CHANGE_STATE', {
        userInfo: {
          account: r.data.game_account,
          roleId: r.data.role_id,
          role: r.data.role_name,
          serverId: r.data.server_id,
          server: r.data.server_name,
          bind_type: r.data.bind_type ? r.data.bind_type : 2,
          mobile: r.data.mobile,
        },
      });
      console.log('nihao nia hdoasho sahd o', this.userInfo);
    },
    showRecord() {
      if (!this.userInfo.roleId) {
        this.$toast('请先登录账号');
        this.bindShow = true;
      } else {
        this.$router.push({ name: 'tgStore.record', query: { config_id: this.configId } });
      }
    },
    async handleInputBlur() {
      console.log(this.bind_type);
      if (this.bind_type == 1) {
        if (this.account && this.password) {
          try {
            // 验证账号密码
            await accountCheck({ account: this.account, password: this.password });
            this.clearRole();
            this.getServer();
            this.isSelectServer = false;
          } catch (error) {
            this.clearRole();
            Toast(error.message);
          }
        }
      } else {
        // 验证手机号
        if (this.phoneNumber && this.phoneCode) {
          try {
            // 2025.12.20 改造，太古商城的绑定账号需要走选择账号弹窗
            check_code_list({ phone: this.phoneNumber, code: this.phoneCode }).then(res => {
              if (res.data && res.data.length > 0) {
                this.$refs.accountSelectDialog.open(res.data, this.phoneNumber);
              } else {
                Toast.fail('未查询到相关账号');
              }
            })
          } catch (error) {
            this.clearRole();
            Toast(error.message);
          }
        }
      }
      console.log('this.serverList', this.serverList);
    },
    async handleAccountSelect(res) {
      this.clearRole();
      this.getServer();
      this.isSelectServer = false;
    },
    clearRole() {
      this.roleList = [];
      this.serverList = [];
      this.server = '';
      this.role = '';
    },
    // type 1.更换角色
    async getServer(type) {
      let params = {};
      if (this.bind_type == 1) {
        (params.account = this.account || this.userInfo.account),
          (params.config_id = this.configId),
          (params.bind_type = this.bind_type);
      } else {
        (params.phone = this.phoneNumber || this.userInfo.mobile),
          (params.config_id = this.configId),
          (params.bind_type = this.bind_type);
      }
      console.log('params', params);
      try {
        const r = await serverRoleOption(params);
        if (r.data.role_list && r.data.role_list.length) {
          const serverList = [];
          r.data.role_list.map((item) => {
            const exist = serverList.findIndex(
              (serverItem) => serverItem.value === item.server_id,
            );
            if (exist !== -1) {
              serverList[exist].children.push({
                value: item.role_id,
                text: item.role_name,
                user_id: item.user_id,
              });
            } else {
              serverList.push({
                text: item.server_name,
                value: item.server_id,
                children: [
                  {
                    value: item.role_id,
                    text: item.role_name,
                    user_id: item.user_id,
                  },
                ],
              });
            }
          });
          this.serverList = serverList;
          this.roleList = [];
          this.role = '';
        } else {
          this.clearRole();
        }
      } catch (error) {
        this.clearRole();
        Toast(error.message);
      }
    },
    selectServer({ text, value, children }) {
      if (value !== this.server) {
        this.server = value;
        this.server_name = text;
        this.roleList = children;
        this.role = '';
      }
    },
    selectRole({ text, value, user_id }) {
      this.role = value;
      this.role_name = text;
      this.user_id = user_id;
    },
    async bindRole() {
      this.account = this.account || this.userInfo.account;
      let data = {};
      if (this.bind_type == 1) {
        if (!this.account || !this.server || !this.role) {
          Toast('请补全角色信息');
          return;
        }
        data.bind_type = this.bind_type;
        data.account = this.account;
        data.config_id = this.configId;
        data.server_id = this.server;
        data.server_name = this.server_name;
        data.role_id = this.role;
        data.role_name = this.role_name;
      } else {
        if (!this.phoneNumber && !this.userInfo.mobile) {
          Toast('请补全角色信息');
          return;
        }
        data.bind_type = this.bind_type;
        data.phone = this.phoneNumber || this.userInfo.mobile;
        data.config_id = this.configId;
        data.server_id = this.server;
        data.server_name = this.server_name;
        data.role_id = this.role;
        data.role_name = this.role_name;
      }
      try {
        const r = await bindRoleApi(data);

        this.appkey = r.data.app_key;
        let tokenNameList = localStorage.getItem('tokenNameList') || '';
        tokenNameList = tokenNameList.split(',').filter(token => token); // 过滤空字符串
        // 去重：只有当token_name不存在时才添加
        if (!tokenNameList.includes(r.data.token_name)) {
          tokenNameList.push(r.data.token_name);
        }
        localStorage.setItem('tokenNameList', tokenNameList.join(','));
        localStorage.setItem(r.data.token_name, r.data.token_value);
        Toast('绑定成功');
        await this.getUserInfo();
        console.log(this.userInfo);
        this.$store.commit('tgStore/CHANGE_STATE', {
          userInfo: {
            account: this.userInfo.account,
            serverId: this.server,
            server: this.server_name,
            role: this.role_name,
            roleId: this.role,
            appkey: r.data.app_key,
            config_id: this.configId,
            bind_type: this.bind_type,
            mobile: this.bind_type == 2 ? (this.phoneNumber || this.userInfo.mobile) : '',
          },
        });
        this.getProductList();
        this.bindShow = false;
        this.updateBindFlag = false;
      } catch (error) {
        error.message && this.$toast(error.message);
      }
    },
    showBind() {
      this.bind_type = this.userInfo.bind_type ? this.userInfo.bind_type : this.bind_type;
      console.log(this.bind_type);
      this.phoneNumber = '';
      this.phoneCode = '';
      shopData({ type: this.userInfo.role ? 3 : 2, config_id: this.configId });
      this.hasVerifyCode = false;
      this.bindShow = true;
      this.account = '';
      this.password = '';
      this.server = '';
      this.server_name = '';
      this.role = '';
      this.role_name = '';
      if (this.userInfo.account) {
        this.getServer(1);
        shopData({ type: 4, config_id: this.configId });
      }
    },
    // 滚动到需要高亮的商品
    scrollToHighlightedGood() {
      if (!this.highlightGoodId) return;
      
      // 首先在当前激活的tab中查找商品
      let goods = this.subShopGoodsMap[this.activeTab] || [];
      let goodIndex = goods.findIndex(item => item.id == this.highlightGoodId);
      let targetTabId = this.activeTab;
      
      // 如果在当前tab中没找到，尝试在所有tab中查找
      if (goodIndex === -1) {
        for (const shopId in this.subShopGoodsMap) {
          goods = this.subShopGoodsMap[shopId] || [];
          goodIndex = goods.findIndex(item => item.id == this.highlightGoodId);
          if (goodIndex !== -1) {
            targetTabId = Number(shopId);
            // 切换到找到商品的tab
            this.activeTab = targetTabId;
            break;
          }
        }
      }
      
      if (goodIndex !== -1) {
        // 等待DOM更新后滚动到商品位置
        this.$nextTick(() => {
          const goodElements = document.querySelectorAll(`.${this.$style.productList} li`);
          if (goodElements && goodElements[goodIndex]) {
            // 为目标商品添加高亮样式
            goodElements[goodIndex].style.backgroundColor = '#FFE16A';
            
            // 滚动到商品位置
            goodElements[goodIndex].scrollIntoView({ behavior: 'smooth', block: 'center' });
            
            // 5秒后移除高亮效果
            setTimeout(() => {
              goodElements[goodIndex].style.backgroundColor = '';
              goodElements[goodIndex].style.boxShadow = '';
            }, 5000);
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" module>
.get-code-btn {
  padding: 0 15px;
  height: 30px;
  border-radius: 20px;
  color: #33bdfe;
  border-color: #33bdfe;
  font-size: 12px;
}
.white_space_pre {
  white-space: pre;
}
.tgStore {
  width: 100%;
  min-height: 750px;
  background: #f6f6f6;
  > h1 {
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: relative;
    padding: 10px 0;
    font-size: 18px;
    > img {
      position: absolute;
      left: 10px;
      width: 8px;
      height: 15px;
    }
  }
  .banner {
    width: 100%;
    margin-bottom: 7px;
  }
  .game {
    width: 354.17px;
    height: 104px;
    background: #ffffff;
    border-radius: 6.94px;
    margin: auto;
    padding: 10px 0;
    margin-top: 15px;
    .gameInfo {
      display: flex;
      margin-left: 10px;
      align-items: flex-start;
      position: relative;
      top: -30px;
      > img {
        width: 76px;
        height: 76px;
        margin-right: 8px;
      }
      > div {
        margin-top: 30px;
        > p {
          color: #bbbbbb;
          font-size: 10px;
          line-height: 14px;
        }
        > .title {
          font-size: 15px;
          font-weight: 500;
          text-align: left;
          color: #ff7a21;
          margin-bottom: 5px;
        }
      }
    }
    .operate {
      display: flex;
      justify-content: center;
      margin-top: -15px;
      > li {
        display: flex;
        align-items: center;
        color: #ff7a21;
        font-size: 10px;
        width: 80px;
        height: 24px;
        background: #fafafa;
        border-radius: 7px;
        margin: 0 12px;
        justify-content: center;
        &:active {
          opacity: 0.8;
        }
        img {
          width: 10px;
          height: 10px;
          margin-right: 2px;
        }
      }
    }
  }
  .product {
    background: #ffffff;
    width: 354.17px;
    border-radius: 6.94px;
    margin: auto {
      top: 7px;
    }
    padding: 10px 0;
    .tabs {
      margin: 10px 0;
      overflow-x: auto;
      width: 354.17px;
      height: 20px;
      padding: 0 20px;
      .tabsItem {
        display: flex;
        justify-content: flex-start;
        > div {
          flex: none;
          margin: 0 20px 0 0;
          font-size: 13px;
          color: #bbbbbb;
          &.active {
            font-size: 15px;
            font-weight: 500;
            color: #333333;
            position: relative;
            &:before {
              position: absolute;
              top: 47%;
              left: 0;
              content: ' ';
              width: 37.5px;
              height: 4.86px;
              background: linear-gradient(to right, #ff8c25 0%, rgba(255, 242, 242, 0) 100%);
            }
            > span {
              position: relative;
              z-index: 1;
            }
          }
        }
      }
    }
    .hint {
      text-align: left;
      color: #999999;
      font-size: 10px;
      padding-left: 10px;
      margin-bottom: 10px;
    }
    .hint_2 {
      text-align: left;
      color: #f10606;
      font-size: 10px;
      padding-left: 10px;
      margin: 15px 0;
    }
    .productList {
      > li {
        display: flex;
        align-items: center;
        position: relative;
        padding: 5px 10px;
        margin: 10px auto;
        width: 98%;
        border-radius: 8px;
        > img {
          width: 76px;
          height: 76px;
          margin-right: 4px;
        }
        > .detail {
          > .name {
            font-size: 15px;
            font-weight: 500;
            text-align: left;
            color: #111111;
          }
          > .price {
            margin: 4px 0;
            display: flex;
            align-items: center;
            .discount {
              color: #ffffff;
              font-size: 8px;
              background: url('//static.hzwxbz3.cn/Lianyun/font_end/HeiMiaoPlatform/tgStore/tag1.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              margin-right: 2px;
              padding: 4px 8px 4px 4px;
            }
            .price {
              color: #ff5959;
              font-size: 15px;
              font-weight: 500;
              margin-right: 6px;
            }
            .original {
              font-size: 10px;
              font-weight: 400;
              text-align: left;
              color: #666666;
              text-decoration: line-through;
            }
          }
          .purchase {
            font-size: 10px;
            font-weight: 400;
            color: #666666;
            margin: 2px 0;
            > .bl {
              color: #5b98ec;
            }
          }
          .endTime {
            font-size: 10px;
            font-weight: 400;
            color: #666666;
            > span {
              color: #bbbbbb;
            }
          }
        }
        > .storeOperate {
          position: absolute;
          right: 10px;
          > button {
            width: 70px;
            height: 24px;
            background: #ff7a21;
            border-radius: 4px;
            border: none;
            outline: none;
            color: #ffffff;
            font-size: 11px;
            &:active {
              opacity: 0.9;
            }
          }
          .pre {
            background: #f1f8ff;
            color: #5b98ec;
          }
          .run {
            background: #fff8f1;
            color: #909090;
          }
          > p {
            font-size: 9px;
            font-weight: 400;
            text-align: center;
            color: #999999;
            line-height: 20px;
          }
        }
      }
    }
  }
  .bindMask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 10;
    .bind {
      width: 278px;
      height: 350px;
      border-radius: 7px;
      background: #ffffff;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      > h1 {
        width: 100%;
        height: 41px;
        text-align: center;
        border-radius: 7px;
        background-color: #ffb368;
        color: #ffffff;
        font-size: 17px;
        // font-weight: bold;
        // border-radius: 6px;
        line-height: 41px;
        position: relative;
        > img {
          position: absolute;
          top: 10px;
          right: 12px;
          width: 15px;
          height: 15px;
        }
      }
      .content {
        padding: 15px;
        > p {
          color: #666666;
          font-size: 14px;
          margin: 8px 0;
        }
        .accountView {
          background-color: #f6f6f6;
          border: none;
          padding: 10px 8px;
          // margin-bottom: 10px;
          .account {
            display: inline-block;
            color: #ff7a21;
            text-align: center;
            width: 150px;
          }
          .btn {
            color: #5b98ec;
            font-size: 10px;
            padding: 5px 15px;
            &:active {
              opacity: 0.8;
            }
          }
        }
        .field {
          background-color: #f6f6f6;
          border: none;
          padding: 4px 8px;
          margin-bottom: 10px;
        }
        :global {
          .yw-select-wrap {
            width: 100%;
            background-color: #f6f6f6;
            color: #b4afaf;
            border: none;
          }
        }
      }
      .btnGroup {
        position: absolute;
        bottom: 15px;
        left: 15px;
        right: 15px;
        display: flex;
        justify-content: center;
        .cancel,
        .nextStep {
          width: 111px;
          height: 38px;
          border-radius: 6px;
        }
        .cancel {
          border: 1px solid #b2b2b2;
          color: #999999;
        }
        .nextStep {
          background: #ff7a21;
          color: #ffffff;
        }
      }
    }
    .intro {
      @extend .bind;
      height: 100px;
      > p {
        padding: 4px;
        color: #666666;
      }
    }
  }
}
</style>
